import {axios} from '@/utils/request'

// 查询流程定义列表
export function listDefinition(query) {
  return axios({
    url: '/jeecg-oa/flowable/definition/list',
    method: 'get',
    params: query,
    timeout: 30000 // 设置该请求的超时时间为15秒
  })
}

// 部署流程实例,流程定义id
export function definitionStartByDefId(procDefId,data) {
  return axios({
    url: '/jeecg-oa/flowable/definition/startByProcDefId/' + procDefId,
    method: 'post',
    data: data
  })
}


// 部署流程实例，流程定义key
export function definitionStartByDefKey(procDefKey,data) {
  return axios({
    url: '/jeecg-oa/flowable/definition/startByProcDefKey/' + procDefKey,
    method: 'post',
    data: data
  })
}
// 部署流程实例,业务数据dataid

export function definitionStartByDataId(dataId,serviceName,data) {
  return axios({
    url: '/jeecg-oa/flowable/definition/startByDataId/' + dataId + '/' + serviceName,
    method: 'post',
    data: data
  })
}

// 查询当前节点是否是属于退回或驳回的第一个发起人节点,业务数据dataid

export function isFirstInitiator(dataId,data) {
  return axios({
    url: '/jeecg-oa/flowable/task/isFirstInitiator/' + dataId,
    method: 'post',
    data: data
  })
}

// 删除自定义业务任务关联表与流程历史表
//以便可以重新发起流程,业务数据dataid

export function deleteActivityAndJoin(dataId,data) {
  return axios({
    url: '/jeecg-oa/flowable/task/deleteActivityAndJoin/' + dataId,
    method: 'post',
    data: data
  })
}

// 部署流程实例,online数据dataid

export function definitionStartByOnlineDataId(dataId,onlineId,deployId,data) {
  return axios({
    url: '/jeecg-oa/flowable/definition/startByOnlineDataId/' + dataId + '/' + onlineId + '/' + deployId,
    method: 'post',
    data: data
  })
}

// 获取流程变量
export function getProcessVariables(taskId) {
  return axios({
    url: '/jeecg-oa/flowable/task/processVariables/' + taskId,
    method: 'get'
  })
}

// 激活/挂起流程
export function updateState(params) {
  return axios({
    url: '/jeecg-oa/flowable/definition/updateState',
    method: 'put',
    params: params
  })
}

// 指定流程办理人员列表
export function userList(query) {
  return axios({
    url: '/jeecg-oa/flowable/definition/userList',
    method: 'get',
    params: query
  })
}

// 指定流程办理组列表
export function roleList(query) {
  return axios({
    url: '/jeecg-oa/flowable/definition/roleList',
    method: 'get',
    params: query
  })
}
// 指定流程分类列表
export function categoryList(query) {
  return axios({
    url: '/jeecg-oa/flowable/definition/categoryList',
    method: 'get',
    params: query
  })
}

// 读取xml文件
export function readXml(deployId) {
  return axios({
    url: '/jeecg-oa/flowable/definition/readXml/' + deployId,
    method: 'get'
  })
}
// 读取xml文件
export function readXmlByDataId(dataId) {
  return axios({
    url: '/jeecg-oa/flowable/definition/readXmlByDataId/' + dataId,
    method: 'get'
  })
}

// 读取xml文件
export function readXmlByName(processDefinitionName) {
  return axios({
    url: '/jeecg-oa/flowable/definition/readXmlByName/' + processDefinitionName,
    method: 'get'
  })
}

// 读取image文件
export function readImage(deployId) {
  return axios({
    url: '/jeecg-oa/flowable/definition/readImage/' + deployId,
    method: 'get'
  })
}

// 读取image文件
export function getFlowViewer(procInsId) {
  return axios({
    url: '/jeecg-oa/flowable/task/flowViewer/' + procInsId,
    method: 'get'
  })
}
// 读取image文件
export function getFlowViewerByDataId(dataId) {
  return axios({
    url: '/jeecg-oa/flowable/task/flowViewerByDataId/' + dataId,
    method: 'get'
  })
}

// 读取image文件
export function getFlowViewerByName(processDefinitionName) {
  return axios({
    url: '/jeecg-oa/flowable/task/flowViewerByName/' + processDefinitionName,
    method: 'get'
  })
}

// 读取xml文件
export function saveXml(data) {
  return axios({
    url: '/jeecg-oa/flowable/definition/save',
    method: 'post',
    data: data
  })
}

// 删除流程定义
export function delDeployment(query) {
  return axios({
    url: '/jeecg-oa/flowable/definition/delete/',
    method: 'delete',
    params: query
  })
}

// 删除流程定义
export function listallnode(processName) {
  return axios({
    url: '/jeecg-oa/flowable/definition/listallnode/',
    method: 'post',
    params: processName
  })
}
